export { default as DefaultView } from "./large-view/default-view";
export { default as MobileView } from "./mobile-view/mobile-view";
export { default as getIcon } from "./getIcon";
